<template>
  <b-card-group deck class="text-center clickable mb-4 mt-2">
    <b-card
      body-class="align-items-center d-flex justify-content-center"
      :bg-variant="activeCard === 0 ? 'primary' : ''"
      :text-variant="activeCard === 0 ? 'white' : ''"
      @click="$emit('changeCard', 0)"
    >
      <b-card-text>
        <h4>{{ labels.presentCulture }}</h4>
        <p v-if="votes > 0">
          {{ votes }}
          {{ votes === 1 ? labels.vote : labels.votes }}
        </p>
      </b-card-text>
    </b-card>
    <b-card
      body-class="align-items-center d-flex justify-content-center mt-3"
      :bg-variant="activeCard === 1 ? 'primary' : ''"
      :text-variant="activeCard === 1 ? 'white' : ''"
      @click="$emit('changeCard', 1)"
    >
      <b-card-text>
        <h4>{{ labels.culturalAlignment }}</h4>
        <h5 v-if="showCulturalAlignment">
          {{ culturalAlignment.score }}% | {{ culturalAlignmentLabel }}
        </h5>
        <p v-if="showCulturalAlignment">
          {{ culturalAlignment.totalFavorable }}
          {{
            culturalAlignment.totalFavorable === 1 ? labels.vote : labels.votes
          }}
        </p>
        <b-button
          v-if="isAdmin"
          variant="tertiary"
          @click.stop="$emit('showModal')"
        >
          {{ labels.configurations }}
        </b-button>
      </b-card-text>
    </b-card>
    <b-card
      body-class="align-items-center d-flex justify-content-center"
      :bg-variant="activeCard === 2 ? 'secondary' : ''"
      :text-variant="activeCard === 2 ? 'white' : 'secondary'"
      @click="$emit('changeCard', 2)"
    >
      <b-card-text>
        <h4>{{ labels.culturalEntropy }}</h4>
        <h5 v-if="culturalEntropy">
          {{ culturalEntropy.score }}% | {{ culturalEntropyLabel }}
        </h5>
        <p v-if="culturalEntropy">
          {{ culturalEntropy.totalUnfavorable }}
          {{
            culturalAlignment.totalUnfavorable === 1
              ? labels.vote
              : labels.votes
          }}
        </p>
      </b-card-text>
    </b-card>
  </b-card-group>
</template>

<script>
import { mapGetters } from 'vuex'
import { isAdmin } from '@/service/user'

const props = {
  activeCard: {
    type: Number,
    default: 0,
  },
  culturalEntropy: {
    type: Object,
    default: {},
  },
  culturalAlignment: {
    type: Object,
    default: {},
  },
  votes: {
    type: Number,
    default: 0,
  },
  showCulturalAlignment: {
    type: Boolean,
    default: false,
  },
}

export default {
  props,
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    isAdmin() {
      return isAdmin()
    },
    labels() {
      return this.resources.component.culture.dashboardCards
    },
    culturalEntropyLabel() {
      const culturalEntropy = this.culturalEntropy
      if (!culturalEntropy) return ''

      const lb = this.labels.scaleLabels

      const score = this.culturalEntropy.score
      switch (true) {
        case score <= 10:
          return lb.veryLow
        case score <= 20:
          return lb.low
        case score <= 30:
          return lb.medium
        case score <= 40:
          return lb.high
        default:
          return lb.veryHigh
      }
    },
    culturalAlignmentLabel() {
      const culturalAlignment = this.culturalAlignment
      if (!culturalAlignment) return ''

      const lb = this.labels.scaleLabels

      const score = this.culturalAlignment.score
      switch (true) {
        case score < 25:
          return lb.veryLow
        case score < 35:
          return lb.low
        case score < 65:
          return lb.medium
        case score < 75:
          return lb.high
        default:
          return lb.veryHigh
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
